import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getSettlementOverviewApi } from '~/features/dashboard/api/get-settlement-overview.api';
import { getSettlementStoreDetailApi } from '~/features/dashboard/api/get-settlement-store-detail.api';

import type {
  SettlementOverview,
  SettlementParams,
  StoreSettlementDetail,
  StoreSettlementParams,
} from '~/features/dashboard/types/settlement.type';

interface SettlementState {
  overview: SettlementOverview | null;
  storeDetail: StoreSettlementDetail | null;
  isLoading: boolean;
  isDetailLoading: boolean;
}

const initialState: SettlementState = {
  overview: null,
  storeDetail: null,
  isLoading: false,
  isDetailLoading: false,
};

export const fetchSettlementOverview = createAsyncThunk(
  'settlement/fetchOverview',
  async (params: SettlementParams) => {
    const response = await getSettlementOverviewApi(params);
    return response.data.data;
  },
);

export const fetchSettlementStoreDetail = createAsyncThunk(
  'settlement/fetchStoreDetail',
  async (params: StoreSettlementParams) => {
    const response = await getSettlementStoreDetailApi(params);
    return response.data.data;
  },
);

const settlementSlice = createSlice({
  name: 'settlement',
  initialState,
  reducers: {
    clearStoreDetail: state => {
      state.storeDetail = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSettlementOverview.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchSettlementOverview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.overview = action.payload;
      })
      .addCase(fetchSettlementOverview.rejected, state => {
        state.isLoading = false;
      })
      .addCase(fetchSettlementStoreDetail.pending, state => {
        state.isDetailLoading = true;
      })
      .addCase(fetchSettlementStoreDetail.fulfilled, (state, action) => {
        state.isDetailLoading = false;
        state.storeDetail = action.payload;
      })
      .addCase(fetchSettlementStoreDetail.rejected, state => {
        state.isDetailLoading = false;
      });
  },
});

export const { clearStoreDetail } = settlementSlice.actions;
export default settlementSlice;
